import { useEffect, useState } from 'react';
import { loadEntitlement } from '../lib/entitlement.ts';
import { ChatSession } from '../lib/session.ts';

/**
 * Eine ChatSession pro Kamera-Stream. Sie wird im Effect erzeugt (nicht beim Rendern), damit
 * StrictMode im Dev-Modus keine WebSocket-Verbindung verwaisen lässt. Spätere Änderungen der
 * Freischaltung gibt ChatScreen per session.setEntitlement weiter.
 */
export function useChatSession(localStream: MediaStream): ChatSession | null {
  const [session, setSession] = useState<ChatSession | null>(null);

  useEffect(() => {
    const created = new ChatSession({
      localStream,
      entitlementToken: loadEntitlement()?.token ?? null,
    });
    setSession(created);
    return () => {
      created.destroy();
      setSession(null);
    };
  }, [localStream]);

  return session;
}
